<script lang="ts" setup>
import CatalogContent from "~/components/catalogs/CatalogContent.vue";
</script>

<template>
    <CatalogContent />
</template>

<style scoped></style>
